"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartDeleteValueVoucher = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackCartDeleteValueVoucher() {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.ClickEventType.TEXT_CLICK,
        eventLabel: enums_1.EventLabelCartTextClickEnum.DeleteValueVoucher,
        eventData: {
            feature_category: enums_1.GA4FeatureCategory.Cart,
            eventName: enums_1.GA4EventName.DeleteVoucher,
        },
    });
}
exports.trackCartDeleteValueVoucher = trackCartDeleteValueVoucher;
//# sourceMappingURL=trackCartDeleteValueVoucher.js.map